// title
// description

import { Typography } from "@mui/material";
import { PageContainer, PageFull } from "./Pages";
import SectionTitle from "./SectionTitle";

export default function Description({ title, description }) {
    return (
        <PageFull
            sx={{
                // background: "linear-gradient(0deg,rgb(192, 32, 80),rgb(235, 183, 200))",
                // color: 'white'
                paddingY: 5,
                paddingX: 2,
            }}
        >
            <SectionTitle title={title} 
                // color={'white'}
            />
            <Typography
            sx={{
                textAlign:'justify',
                textIndent: '80px',
                
            }}
            >{description}
            </Typography>
        </PageFull>
    );
}